const mobileHeader = () => {
    const htmlElement = document.querySelector('html');
    const toggleBtn   = document.querySelector('.toggle-menu');
    const mobileModal = document.querySelector('.header');
    const mobileMenu  = mobileModal.querySelector('.header__menu');
    const links       = mobileMenu.querySelectorAll('a');

    toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        toggleBtn.classList.toggle('is-open');
        mobileModal.classList.toggle('is-open');
        htmlElement.classList.toggle('is-open');
    });

    links.forEach( link => {
        link.addEventListener('click', () => {
            if( htmlElement.classList.contains('is-open') ) {
                htmlElement.classList.remove('is-open');
                mobileModal.classList.remove('is-open');
                toggleBtn.classList.remove('is-open');
            }  
        })
    })
}

export default mobileHeader;